import { render, staticRenderFns } from "./GridSkeletonLoader.vue?vue&type=template&id=b2041f84&scoped=true"
import script from "./GridSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./GridSkeletonLoader.vue?vue&type=script&lang=ts"
import style0 from "./GridSkeletonLoader.vue?vue&type=style&index=0&id=b2041f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2041f84",
  null
  
)

export default component.exports